var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrlLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 67,
    viewBox: "0 0 58 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6453_3061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.568359 17.8731C0.887159 17.9836 28.977 34.1215 28.977 34.1215V1.71777L0.568359 17.8731Z",
    fill: "#F6BB5D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.568359 50.207L28.977 34.1273L0.568359 17.8789V50.207Z",
    fill: "#D9DDDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.977 34.1279V66.3688L0.568359 50.2076L28.977 34.1279Z",
    fill: "#F7F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3921 17.8731C57.0674 17.9836 28.9775 34.1215 28.9775 34.1215V1.71777L57.3921 17.8731Z",
    fill: "#EC7E54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3862 50.207L28.9775 34.1273L57.3862 17.8789V50.207Z",
    fill: "#C22435"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3862 50.2076L28.9775 34.1279V66.3688L57.3862 50.2076Z",
    fill: "#2486C4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6453_3061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.1395,
    height: 65.9302,
    fill: "white",
    transform: "translate(0.441895 0.301758)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrlLogo);
export default __webpack_public_path__ + "static/media/Prl_Logo.e3d9aa59a9e54590647e7cfee4d4861e.svg";
export { ForwardRef as ReactComponent };